import Typography from '#components/typography/Typography';
import { LivestreamLabelMap } from '#config';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { LivestreamState } from '#types/generated/graphql-types';

type Props = {
  streamState: LivestreamState;
  classes?: string;
};

const LivestreamStateDisplay = ({ streamState, classes = '' }: Props) => {
  const { t } = useTranslation();
  return (
    <Typography
      element="span"
      fontWeight="black"
      effect="gradient-box"
      color="primary"
      classes={`tw-px-1.5 tw-mb-4 ${classes}`}
    >
      {t(LivestreamLabelMap[streamState])}
    </Typography>
  );
};

export default LivestreamStateDisplay;
